var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-button-list"},[_c('div',{staticClass:"radio-button-list-class"},_vm._l((_vm.displayReservationPurposes),function(reservationPurpose){return _c('radio-button-list-item',{key:reservationPurpose.id,attrs:{"reservationPurpose":reservationPurpose,"timeShowFlg":_vm.timeShowFlg},on:{"click":_vm.handleClick}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }